import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-557773cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "access-denied-page" }
const _hoisted_2 = { class: "access-denied-panel bg-white" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "access-denied-icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-lock-key" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "access-denied-eyebrow" }, "Acesso restrito", -1))
const _hoisted_5 = { class: "fw-bold text-black mb-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Entre em contato com o administrador do sistema para solicitar acesso a este modulo. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("h1", _hoisted_5, " Voce nao tem permissao para acessar " + _toDisplayString(_ctx.moduleName), 1),
      _hoisted_6
    ])
  ]))
}